/**
 * PSDK
 */
import {Command} from "./command";
import {Commander} from "./command";
import {ConnectedDevice, WroteReporter} from "../device/adapter";
import {PsdkConst, WriteOptions} from "./types";
import {Arg, Raw} from "./args";
import {DataWriteOperation} from "./device/write_operation";

export abstract class PSDK<_Self extends PSDK<any>> {
  /**
   * Get commander
   */
  abstract commander(): Commander;

  /**
   * Connected device
   */
  abstract connectedDevice(): ConnectedDevice;

  /**
   * sdk version
   */
  sversion(): string {
    return '0.2.67';
  }

  /**
   * authors
   */
  authors(): Array<string> {
    return PsdkConst.DEF_AUTHORS;
  }

  /**
   * Push raw command
   * @param raw raw
   */
  raw(raw: Raw): _Self {
    this.commander().pushArg(raw);
    return this as unknown as _Self;
  }

  /**
   * Put variable
   * @param name name
   * @param value value
   */
  variable(name: string, value: any): _Self {
    this.commander().variable(name, value);
    return this as unknown as _Self;
  }

  /**
   * get command
   */
  command(): Command {
    return this.commander().command();
  }

  /**
   * Clear command
   */
  clear(): _Self {
    this.commander().clear();
    return this as unknown as _Self;
  }

  /**
   * Write data to device
   */
  async write(options?: WriteOptions): Promise<WroteReporter> {
    const connectedDevice = this.connectedDevice();
    if (!connectedDevice)
      throw Error('It\'s seems you missing to set connectedDevice');
    options = options ?? WriteOptions.def();
    const command = this.command();
    const binary = command.binary();
    const operation = new DataWriteOperation(
      options,
      binary,
      connectedDevice
    );
    const reporter = await operation.write();
    this.clear();
    return reporter;
  }

  /**
   * Newline command
   */
  newline(): _Self {
    this.commander().newline();
    return this as unknown as _Self;
  }

  /**
   * Push command
   * @param command
   */
  push(command: Arg<any>): _Self {
    this.commander().pushArg(command);
    return this as unknown as _Self;
  }

}
